import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Table, Spin, Select, Tag } from "antd";
import { ArrowDownOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { labelConfig, staticConfig, apiConfig } from "../product.config";
import { handleFlgStatus } from "../../../components/facilities/AccountFacility";
import CustomPagination from "../../../components/CustomPagination";

const rowSelection = {
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const columns = [
  {
    title: (column) => (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {"Name"}
        <div>
          <ArrowDownOutlined style={{ fontSize: 15, color: "gray" }} />
        </div>
      </div>
    ),
    dataIndex: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: (column) => (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {"Short Name"}
        <div>
          <ArrowDownOutlined style={{ fontSize: 15, color: "gray" }} />
        </div>
      </div>
    ),
    dataIndex: "shortName",
    sorter: (a, b) => a["shortName"].localeCompare(b["shortName"]),
  },

  {
    title: (column) => (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {"Currency"}
        <div>
          <ArrowDownOutlined style={{ fontSize: 15, color: "gray" }} />
        </div>
      </div>
    ),
    dataIndex: "currency",
    sorter: (a, b) => a["currency"].localeCompare(b["currency"]),
  },
  // {
  //   title: "Status",
  //   dataIndex: "active",
  //   render: (_, record) => {
  //     return <div> {handleFlgStatus(record?.active, {}, true)}</div>;
  //   },
  // },
  {
    title: "Status",
    dataIndex: "active",
    key: "status",
    render: (text) => {
      let bgColor = "#F9FAFB"; // default bg
      let textColor = "#344054"; // default text
      let border = "1px solid #EAECF0";

      switch (text) {
        case "Active":
          bgColor = "#ECFDF3";
          textColor = "#067647";
          border = "1px solid #ABEFC6";
          break;
        case "Inactive":
          bgColor = "#FEE4E2";
          textColor = "#B42318";
          border = "1px solid #F0ADAD";
          break;

        default:
          break;
      }

      return (
        <Tag
          style={{
            padding: "2px 12px",
            borderRadius: "16px",
            border: border,
            fontSize: "12px",
            fontWeight: 500,
            display: "inline-block",
            backgroundColor: bgColor,
            color: textColor,
            textTransform: "capitalize",
          }}
        >
          {text}
        </Tag>
      );
    },
  },
];

const productStatusOptions = [
  { value: "status", label: "All Status" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const PRD0100 = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [casaList, setCasaList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [isSearch, setIsSearch] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    BOM.HasPermission("READ_SAVINGSPRODUCT") && getCasaListAction(selectedStatus);
    BOM.HasPermission("CREATE_SAVINGSPRODUCT") && rightAction(cnt.RIGHT_ADD_BTN);
    // dispatch({ type: cnt.CLEAR_RIGHT_BTN, });
  }, [selectedStatus]);

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    // console.log(searchKey);

    if (!searchKey) {
      setCasaList(originalList);
      setIsSearch(false);
      return;
    }
    // console.log(originalList);
    const filterBySearch = originalList.filter(
      (item) =>
        item?.name.toLowerCase()?.includes(searchKey.toLowerCase()) ||
        item?.shortName.toLowerCase()?.includes(searchKey.toLowerCase()) ||
        item?.currency.toLowerCase()?.includes(searchKey.toLowerCase()),
    );
    // console.log(filterBySearch);
    setCasaList(filterBySearch);
    setIsSearch(true);
  }

  function selectTableCount(value) {
    setTableCount(value);
    setIsSearch(false);
  }
  function onRefresh(offset = 0, limit = Number(tableCount)) {
    getCasaListAction(selectedStatus, offset, limit);
    setIsSearch(false);
  }

  const getCasaListAction = (status = selectedStatus, offset = 0, limit = Number(tableCount)) => {
    const params = {
      ...(status !== "status" && { status }),
      offset,
      limit,
    };
    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.GetCasaProductList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        console.log(res);
        const objList = res.pageItems;
        setTotalItems(res.totalFilteredRecords);
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            name: element?.name ? element?.name : "-",
            shortName: element?.shortName ? element?.shortName : "-",
            currency: element?.currency ? element?.currency?.displayLabel : "-",
            // active: handleFlgStatus(element?.active, {}, true),
            active: element?.active ? "Active" : "Inactive",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setCasaList(tempArray.filter((item) => item.disabled === false));
        setCasaList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.GetCasaProductList, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              name: element?.name ? element?.name : "-",
              shortName: element?.shortName ? element?.shortName : "-",
              currency: element?.currency ? element?.currency?.displayLabel : "-",
              active: handleFlgStatus(element?.active, {}, true),
            });
          });
          resolve(tempArray);
        }
      });
    });
  };

  // FLOAT METHODS
  function handleOnView() {
    // console.log(selectedRow);return
    delete selectedRow.amount;
    selectedRow.amount = selectedRow.amountToUse;
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-prd0100", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-prd0100", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-prd0100", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to edit");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_SAVINGSPRODUCT") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_SAVINGSPRODUCT") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent pageTitle={labelConfig.CASAProducts} pageItems={staticConfig.casaProductItems} />

      <Card
        title={`${labelConfig.CASAProduct} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 10px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name, Short Name and Currency"
                style={{
                  width: 400,
                }}
              />
            </div>
            <div style={{ marginBottom: "auto", marginLeft: 0 }}>
              <Select
                value={selectedStatus}
                options={productStatusOptions}
                onChange={setSelectedStatus}
                placeholder={"Select Status"}
                dropdownStyle={{ width: "250px" }}
                className="interbank-table-select"
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={casaList}
              columns={columns}
              fileName={"CASA Product List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              ...rowSelection,
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={casaList}
            bordered
            pagination={false}
          />
          {!isSearch && (
            <CustomPagination
              totalItems={totalItems}
              pageSize={Number(tableCount)}
              onPageChange={(page, offset) => onRefresh(offset)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(PRD0100);
